module.exports = __webpack_public_path__ + "static/media/icon-truck-reclaim-completed.3239d952.png";